import { Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { id } from '@swimlane/ngx-datatable/release/utils';
import { MzBaseModal, MzModalComponent } from 'ngx-materialize';
import { CatalogoModel } from 'src/app/_models/bin-catalogos.model';
import { campos } from 'src/app/_models/formularios/campos.model';
import { valoresSeleccion } from 'src/app/_models/valoresSeleccion.model';
import { REST_SERVICES } from 'src/app/_services/settings';
import { ZeroService } from 'src/app/_services/zero/zero.service';

@Component({
  selector: 'app-modaledit-campos',
  templateUrl: './modaledit-campos.component.html',

})
@Injectable()
export class ModaleditCamposComponent extends MzBaseModal {
  public camposEdit: campos;
  public catPlantilla: CatalogoModel;
  public catSeccion: CatalogoModel;
  public catTipoCampo: CatalogoModel;
  public tipoCampoElegido: boolean;
  public catalogoPlantillas: Array<CatalogoModel>;
  public catalogoSecciones: Array<CatalogoModel>;
  public catalogoTipoCampo: Array<CatalogoModel>;
  public tipoCamp: string;
  public valoresSeleccion: Array<valoresSeleccion>;
  @ViewChild('WarningCam') WarningCam: MzModalComponent;
  @ViewChild('ErrorEditCam') ErrorEditCam: MzModalComponent;


  public modalOptions: Materialize.ModalOptions = {
    dismissible: false,
    opacity: .5,
    inDuration: 300,
    outDuration: 200,
    startingTop: '100%',
    endingTop: '10%',
  };
  @Input() public campoEditIn: campos;

  // Emitter para envío de parámetros
  @Output() updateCamp: EventEmitter<campos>;

  constructor(private zeroService: ZeroService) {
    super();
    this.updateCamp = new EventEmitter();
    this.catalogoPlantillas = new Array<CatalogoModel>();
    this.catalogoSecciones = new Array<CatalogoModel>();
    this.catalogoTipoCampo = new Array<CatalogoModel>();
    this.valoresSeleccion = new Array<valoresSeleccion>();
  }

  ngOnInit() {
    let idAnt = this.campoEditIn.idCampo;
    this.camposEdit = this.campoEditIn;
    this.camposEdit.idAnt = idAnt;
    this.valoresSeleccion = this.campoEditIn.valoresSeleccion;
    this.buscarCatalogosPlantilla();
    this.buscarCatalogosSeccion();
    this.buscarCatalogosTipoCampo();
  }
  buscarCatalogosSeccion() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_SECCIONES,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoSecciones = response.response;
      }
    });
  }

  buscarCatalogosTipoCampo() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_TIPO_CAMPO,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoTipoCampo = response.response;
        this.validaTipoCampo(this.campoEditIn.idTipoCampo);
      }
    });
  }

  buscarCatalogosPlantilla() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CATALOGO_PLANTILLAS,
      method: "GET",
      swhowInfo: true,
      ok: (response) => {
        scope.catalogoPlantillas = response.response;
      }
    });
  }
  cancelar() {
    this.modalComponent.closeModal();
    this.WarningCam.closeModal();
  }
  limpiarRequired(valor: boolean) {
    this.camposEdit.isRequired = valor;
  }
  setEditTipoCampo(idTipo: number) {
    this.camposEdit.idTipoCampo = idTipo;
    this.validaTipoCampo(idTipo)
  }
  validaTipoCampo(idTipo: number) {
    this.tipoCamp = this.catalogoTipoCampo.find(i => i.id == idTipo).descripcion;
    this.tipoCampoElegido = (this.tipoCamp !== 'INPUT TEXT' && this.tipoCamp !== 'TEXT AREA');
    if (this.tipoCampoElegido) {
      this.camposEdit.longitud = null;
      this.camposEdit.expReg = "";
    }
  }
  setEditPlantilla(idPlantilla: number) {
    this.camposEdit.idPlantilla = idPlantilla;
  }
  setEditSeccion(idSeccion: number) {
    this.camposEdit.idSeccion = idSeccion;
  }
  deleteValoresSeleccion(index: number) {
    if (this.valoresSeleccion.length > 1) {
      this.valoresSeleccion.splice(index, 1);
    }
  }

  addValoresSeleccion() {
    let tamValoresSeleccion = this.valoresSeleccion.length
    let valor = tamValoresSeleccion == 0 ? "" : this.valoresSeleccion[tamValoresSeleccion - 1].descripcion;
    if (tamValoresSeleccion < 1 || (valor !== null && valor !== undefined && valor !== "")) {
      let valorSeleccion = new valoresSeleccion();
      valorSeleccion.bubCatCamposConfig = null;
      valorSeleccion.idValorSeleccionPk = null;
      valorSeleccion.valorExtracto = null;
      valorSeleccion.descripcion = null;
      valorSeleccion.valor = null;
      this.valoresSeleccion.push(valorSeleccion)
    }

  }
  public closeModal() {
    if (this.camposEdit.descCampo == null ||
      (!this.tipoCampoElegido && this.camposEdit.longitud < 1) ||
      (!this.tipoCampoElegido && this.camposEdit.expReg == null) ||
      (this.camposEdit.idTipoCampo == 4 && (this.valoresSeleccion == null ||
        this.valoresSeleccion == undefined || this.valoresSeleccion.length < 1)) ||
      this.camposEdit.orden == null ||
      this.camposEdit.idPlantilla == null ||
      this.camposEdit.idSeccion == null ||
      this.camposEdit.idTipoCampo == 0
    ) {
      this.ErrorEditCam.openModal();
    } else {
      if (this.camposEdit.idAnt != this.camposEdit.idCampo) {
        this.WarningCam.openModal();
      } else {
        this.updateCamp.emit(this.camposEdit);
        this.modalComponent.closeModal();
      }

    }
  }

  public closeModalwarning() {
    this.updateCamp.emit(this.camposEdit);
    this.cancelar();
  }
}
